// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Modal,
//   Form,
//   Table,
//   Spinner,
// } from 'react-bootstrap';
// import { Pencil } from 'lucide-react';
// import { FaSearch, FaTrash } from 'react-icons/fa';
// import Swal from 'sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';

// const API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/subdivisions/';

// const SubdivisionManager = () => {
//   const [subdivisions, setSubdivisions] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [subdivisionInput, setSubdivisionInput] = useState('');
//   const [editItem, setEditItem] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isPageLoading, setIsPageLoading] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isDeletingId, setIsDeletingId] = useState(null);

//   const token = localStorage.getItem('jwttoken');

//   useEffect(() => {
//     fetchSubdivisions();
//   }, []);

//   const fetchSubdivisions = async () => {
//     setIsPageLoading(true);
//     try {
//       const res = await fetch(API_URL, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!res.ok) {
//         const error = await res.json();
//         Swal.fire('Error', error.detail || 'Failed to fetch subdivisions', 'error');
//         return;
//       }

//       const data = await res.json();
//       setSubdivisions(data);
//     } catch (err) {
//       console.error(err);
//       Swal.fire('Error', 'Network error', 'error');
//     } finally {
//       setIsPageLoading(false);
//     }
//   };

//   const handleShowModal = () => {
//     setSubdivisionInput('');
//     setEditItem(null);
//     setShowModal(true);
//   };

//   const handleClose = () => {
//     setSubdivisionInput('');
//     setEditItem(null);
//     setShowModal(false);
//   };

//   const handleAddOrUpdate = async () => {
//     const trimmed = subdivisionInput.trim();
//     if (!trimmed) return;

//     setIsLoading(true);

//     if (editItem) {
//       // PATCH
//       try {
//         const res = await fetch(`${API_URL}${editItem.id}/`, {
//           method: 'PATCH',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to update', 'error');
//           return;
//         }

//         Swal.fire('Updated!', 'Subdivision updated successfully.', 'success');
//         fetchSubdivisions();
//         handleClose();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsLoading(false);
//       }
//     } else {
//       // POST
//       try {
//         const res = await fetch(API_URL, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to add subdivision', 'error');
//           return;
//         }

//         Swal.fire('Added!', 'Subdivision added successfully.', 'success');
//         fetchSubdivisions();
//         handleClose();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   const handleEdit = (subdivision) => {
//     setSubdivisionInput(subdivision.name);
//     setEditItem(subdivision);
//     setShowModal(true);
//   };

//   const handleDelete = async (subdivision) => {
//     const confirm = await Swal.fire({
//       title: 'Are you sure?',
//       text: `Delete "${subdivision.name}"?`,
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!',
//     });

//     if (confirm.isConfirmed) {
//       setIsDeletingId(subdivision.id);

//       try {
//         const res = await fetch(`${API_URL}${subdivision.id}/`, {
//           method: 'DELETE',
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to delete', 'error');
//           return;
//         }

//         Swal.fire('Deleted!', 'Subdivision deleted successfully.', 'success');
//         fetchSubdivisions();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsDeletingId(null);
//       }
//     }
//   };

//   const filteredSubdivisions = subdivisions.filter((s) =>
//     s.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="container mt-4">
//       <h4 className="mb-3 text-center">Subdivision Management</h4>

//       <div className="d-flex justify-content-between mb-3">
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             position: 'relative',
//             width: '300px',
//           }}
//         >
//           <FaSearch
//             style={{
//               position: 'absolute',
//               left: '10px',
//               color: '#888',
//             }}
//           />
//           <input
//             type="text"
//             placeholder="Search Subdivision..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               padding: '8px 10px 8px 35px',
//               border: '1px solid #ddd',
//               borderRadius: '5px',
//               width: '100%',
//             }}
//           />
//         </div>

//         <Button
//           onClick={handleShowModal}
//           style={{
//             background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//             color: 'white',
//             border: 'none',
//           }}
//         >
//           + Add Subdivision
//         </Button>
//       </div>

//       {isPageLoading ? (
//         <div className="text-center my-5">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <Table striped hover responsive className="mt-3">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Subdivision Name</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredSubdivisions.length > 0 ? (
//               filteredSubdivisions.map((subdivision) => (
//                 <tr key={subdivision.id}>
//                   <td>{subdivision.id}</td>
//                   <td>{subdivision.name}</td>
//                   <td>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       className="me-2"
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#7366ff',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleEdit(subdivision)}
//                     >
//                       <Pencil size={20} />
//                     </Button>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#ff5370',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleDelete(subdivision)}
//                       disabled={isDeletingId === subdivision.id}
//                     >
//                       {isDeletingId === subdivision.id ? (
//                         <Spinner size="sm" animation="border" />
//                       ) : (
//                         <FaTrash size={20} />
//                       )}
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="3" className="text-center text-muted">
//                   No subdivisions found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       <Modal show={showModal} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{editItem ? 'Edit' : 'Add'} Subdivision</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form.Control
//             type="text"
//             placeholder="Enter subdivision name"
//             value={subdivisionInput}
//             onChange={(e) => setSubdivisionInput(e.target.value)}
//           />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             style={{
//               background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//               color: 'white',
//               border: 'none',
//             }}
//             onClick={handleAddOrUpdate}
//             disabled={isLoading}
//           >
//             {isLoading ? (
//               <Spinner size="sm" animation="border" />
//             ) : (
//               editItem ? 'Update Subdivision' : 'Add Subdivision'
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default SubdivisionManager;



import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Table,
  Spinner,
  Pagination,
} from 'react-bootstrap';
import { Pencil } from 'lucide-react';
import { FaSearch, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/subdivisions/';
const DIVISION_API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/divisions/';

const SubdivisionManager = () => {
  const [subdivisions, setSubdivisions] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [subdivisionInput, setSubdivisionInput] = useState('');
  const [selectedDivision, setSelectedDivision] = useState('');
  const [editItem, setEditItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeletingId, setIsDeletingId] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const token = localStorage.getItem('jwttoken');

  useEffect(() => {
    fetchSubdivisions();
    fetchDivisions();
  }, []);

  const fetchSubdivisions = async () => {
    setIsPageLoading(true);
    try {
      const res = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const error = await res.json();
        Swal.fire('Error', error.detail || 'Failed to fetch subdivisions', 'error');
        return;
      }

      const data = await res.json();
      setSubdivisions(data);
      setCurrentPage(1); // Reset to first page when data changes
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Network error', 'error');
    } finally {
      setIsPageLoading(false);
    }
  };

  const fetchDivisions = async () => {
    try {
      const res = await fetch(DIVISION_API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const error = await res.json();
        console.error('Failed to fetch divisions:', error);
        return;
      }

      const data = await res.json();
      setDivisions(data);
    } catch (err) {
      console.error('Error fetching divisions:', err);
    }
  };

  const handleShowModal = (subdivision = null) => {
    if (subdivision) {
      setSubdivisionInput(subdivision.name);
      setSelectedDivision(subdivision.division || '');
      setEditItem(subdivision);
    } else {
      setSubdivisionInput('');
      setSelectedDivision('');
      setEditItem(null);
    }
    setShowModal(true);
  };

  const handleClose = () => {
    setSubdivisionInput('');
    setSelectedDivision('');
    setEditItem(null);
    setShowModal(false);
  };

  const handleAddOrUpdate = async () => {
    const trimmed = subdivisionInput.trim();
    if (!trimmed || !selectedDivision) {
      Swal.fire('Validation', 'Both subdivision name and division are required!', 'warning');
      return;
    }

    setIsLoading(true);

    const payload = {
      name: trimmed,
      division: selectedDivision
    };

    if (editItem) {
      // PATCH
      try {
        const res = await fetch(`${API_URL}${editItem.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to update', 'error');
          return;
        }

        Swal.fire('Updated!', 'Subdivision updated successfully.', 'success');
        fetchSubdivisions();
        handleClose();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsLoading(false);
      }
    } else {
      // POST
      try {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to add subdivision', 'error');
          return;
        }

        Swal.fire('Added!', 'Subdivision added successfully.', 'success');
        fetchSubdivisions();
        handleClose();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleDelete = async (subdivision) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Delete "${subdivision.name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      setIsDeletingId(subdivision.id);

      try {
        const res = await fetch(`${API_URL}${subdivision.id}/`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to delete', 'error');
          return;
        }

        Swal.fire('Deleted!', 'Subdivision deleted successfully.', 'success');
        fetchSubdivisions();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsDeletingId(null);
      }
    }
  };

  // Filter and pagination logic
  const filteredSubdivisions = subdivisions.filter((s) =>
    s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (s.division && s.division.name.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSubdivisions.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredSubdivisions.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mt-4">
      <h4 className="mb-3 text-center">Subdivision Management</h4>

      <div className="d-flex justify-content-between mb-3">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            width: '300px',
          }}
        >
          <FaSearch
            style={{
              position: 'absolute',
              left: '10px',
              color: '#888',
            }}
          />
          <input
            type="text"
            placeholder="Search Subdivision..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '8px 10px 8px 35px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              width: '100%',
            }}
          />
        </div>

        <Button
          onClick={() => handleShowModal()}
          style={{
            background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
            color: 'white',
            border: 'none',
          }}
        >
          + Add Subdivision
        </Button>
      </div>

      {isPageLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <Table striped hover responsive className="mt-3">
            <thead>
              <tr>
                <th>#</th>
                <th>Subdivision Name</th>
                <th>Division</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((subdivision, index) => (
                  <tr key={subdivision.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{subdivision.name}</td>
<td>
  {
    divisions.find((d) => d.id === subdivision.division)?.name || 'N/A'
  }
</td>
                    <td>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#7366ff',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleShowModal(subdivision)}
                      >
                        <Pencil size={20} />
                      </Button>
                      <Button
                        variant="white"
                        size="sm"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#ff5370',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleDelete(subdivision)}
                        disabled={isDeletingId === subdivision.id}
                      >
                        {isDeletingId === subdivision.id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          <FaTrash size={20} />
                        )}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted">
                    No subdivisions found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          {filteredSubdivisions.length > itemsPerPage && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination>
                <Pagination.First 
                  onClick={() => paginate(1)} 
                  disabled={currentPage === 1} 
                />
                <Pagination.Prev 
                  onClick={() => paginate(currentPage - 1)} 
                  disabled={currentPage === 1} 
                />
                
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => paginate(index + 1)}
                    style={{
                      backgroundColor: index + 1 === currentPage ? 'orange' : '',
                      borderColor: index + 1 === currentPage ? 'orange' : '',
                      color: index + 1 === currentPage ? 'white' : '',
                    }}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                
                <Pagination.Next 
                  onClick={() => paginate(currentPage + 1)} 
                  disabled={currentPage === totalPages} 
                />
                <Pagination.Last 
                  onClick={() => paginate(totalPages)} 
                  disabled={currentPage === totalPages} 
                />
              </Pagination>
            </div>
          )}
        </>
      )}

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editItem ? 'Edit' : 'Add'} Subdivision</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Division</Form.Label>
            <Form.Select
              value={selectedDivision}
              onChange={(e) => setSelectedDivision(e.target.value)}
              required
            >
              <option value="">Select Division</option>
              {divisions.map((division) => (
                <option key={division.id} value={division.id}>
                  {division.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>Subdivision Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter subdivision name"
              value={subdivisionInput}
              onChange={(e) => setSubdivisionInput(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{
              background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
              color: 'white',
              border: 'none',
            }}
            onClick={handleAddOrUpdate}
            disabled={isLoading}
          >
            {isLoading ? (
              <Spinner size="sm" animation="border" />
            ) : (
              editItem ? 'Update Subdivision' : 'Add Subdivision'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubdivisionManager;